<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BjbWOE/tc-custom/Cover.jpg?1688984942395?1710184783939" alt="This image is the cover for the book Planet of the Apes Artist Tribute, Planet of the Apes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Planet of the Apes Artist Tribute, Planet of the Apes
      </h1>
      <p class="bookDescription body article font2">
        <p>Since its original release in 1968, the Planet of the Apes franchise has shocked and captivated authors, artists, filmmakers, and fans across the world with its incredible effects and brilliant narrative. Now, return to the worlds of Planet of the Apes, both old and new, realized by a collection of classic and modern artistic voices in celebration of one of cinema’s most celebrated works. The Planet of the Apes Artist Tribute features illustrations from renowned artists and bold new voices alike, including Alex Ross, Paolo Rivera, Michael Allred, Gabriel Hardman, Joe Quinones, and more.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pierre Boulle, Paolo Rivera, Alex Ross, Michael Allred, Joe Quinones
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6db9bb81